import {DrawingDataItem, DrawingDataItemDrawResult, DrawingDataItemPoint} from "../drawingOnImageDrawingElement.model";

export class DrawingDataItemArrow extends DrawingDataItem {
    constructor() {
        super();
        this.typeValue = 'arrow';
        this.properties = {
            origin: undefined,
            destination: undefined
        }
    }

    public getPointsToMove(): DrawingDataItemPoint[] {
        return [
            DrawingDataItemPoint.fromVisiblePoint(this.properties.origin),
            DrawingDataItemPoint.fromVisiblePoint(this.properties.destination),
        ];
    }

    public onMouseDown(canvasRelativeX: number, canvasRelativeY: number): DrawingDataItemDrawResult {
        if (this.properties.origin) {
            return {
                changed: false,
                stillDrawing: false
            };
        }
        this.properties.origin = {
            x: canvasRelativeX,
            y: canvasRelativeY,
        }
        return {
            changed: true,
            stillDrawing: true
        };
    }

    public onMouseMove(canvasRelativeX: number, canvasRelativeY: number): DrawingDataItemDrawResult {
        this.properties.destination = {
            x: canvasRelativeX,
            y: canvasRelativeY
        }
        return {
            stillDrawing: true,
            changed: true
        };
    }

    public draw(ctx: CanvasRenderingContext2D) {
        const origin = this.properties.origin;
        const destination = this.properties.destination;
        if (origin && destination) {
            // Dessiner la ligne principale de la flèche
            ctx.beginPath();
            this.applyCommonToCanvas(ctx);
            ctx.moveTo(origin.x, origin.y);
            ctx.lineTo(destination.x, destination.y);
            ctx.stroke();

            // Calculer l'angle de la ligne
            const angle = Math.atan2(destination.y - origin.y, destination.x - origin.x);
            const headLength = Math.max(10, this.common.thickness * 3);

            // Calcul des points de l'entête (angle décalé de 30° de chaque côté)
            const arrowPoint1 = {
                x: destination.x - headLength * Math.cos(angle - Math.PI / 6),
                y: destination.y - headLength * Math.sin(angle - Math.PI / 6)
            };

            const arrowPoint2 = {
                x: destination.x - headLength * Math.cos(angle + Math.PI / 6),
                y: destination.y - headLength * Math.sin(angle + Math.PI / 6)
            };

            // Dessiner la première branche de l'entête
            ctx.beginPath();
            this.applyCommonToCanvas(ctx);
            ctx.moveTo(destination.x, destination.y);
            ctx.lineTo(arrowPoint1.x, arrowPoint1.y);
            ctx.stroke();

            // Dessiner la deuxième branche de l'entête
            ctx.beginPath();
            ctx.moveTo(destination.x, destination.y);
            ctx.lineTo(arrowPoint2.x, arrowPoint2.y);
            this.applyCommonToCanvas(ctx);
            ctx.stroke();
        }
    }
}